import { useLocale, useTranslations } from 'next-intl'

import { useSearchFilterStore } from '@/entities/map'
import {
  AutoCompleteInput,
  PeriodPicker,
  useSearch,
} from '@/features/room-search'
import { cn, mapManager } from '@/shared/lib'
import { Button } from '@/shared/ui'

export const SearchBar = () => {
  const t = useTranslations('map')

  const filterActions = useSearchFilterStore(state => state.actions)

  const locale = useLocale()

  const isEnglish = locale === 'en'

  const search: Parameters<typeof useSearch>[0]['search'] = ({
    lat,
    lng,
    zoomLevel,
    startDate,
    endDate,
    keyword,
  }) => {
    if (lat && lng) {
      mapManager.changeMapCenter({ lat, lng, zoomLevel })
    }

    filterActions.update({ startDate, endDate })
    filterActions.updateKeyword(keyword)
  }

  const { autoCompleteInputProps, periodPickerProps, handleSubmit } = useSearch(
    { search },
  )

  return (
    <div
      className={cn(
        'mr-6 flex w-[600px] shrink-0 items-center',
        isEnglish && 'w-[615px]',
      )}
    >
      <div className={cn('flex w-[550px]', isEnglish && 'w-[565px]')}>
        <AutoCompleteInput
          className="-ml-[11px] w-[300px] shrink-0"
          inputClassName="bg-[rgba(0,0,0,0)] border-none w-full text-[15px]! leading-[22px]! h-[50px] *:placeholder:text-gray-400"
          placeholder={t('search.location.placeholder')}
          popupSideOffset={2}
          {...autoCompleteInputProps}
        />
        <PeriodPicker
          className={cn(
            'h-[50px] w-[265px] shrink-0 focus-visible:outline-none',
            isEnglish && 'w-[280px]',
          )}
          placeholder={t('search.date.placeholder')}
          alignOffset={16}
          sideOffset={2}
          {...periodPickerProps}
        />
      </div>
      <Button
        size="small"
        weight="normal"
        className="w-[50px]"
        onClick={handleSubmit}
      >
        {t('search.button')}
      </Button>
    </div>
  )
}
